// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"cd6fda52","43":"3727b762","122":"a659caf4","137":"1848cc79","382":"df0a2b6c","394":"e4b34f26","782":"05fdffbe","892":"be73317d","950":"78ccf31c"}[chunkId] + ".chunk.js";
};